import { useEffect, useState } from 'react';
import { SkeletonLoading } from '@app/shared';
import { DefaultProps } from '@app/Types/global.interfaces';
import { fetchRatingShops, RatingShopsType } from '../../module/services/getRatingShops';
import { RatingByShopTemplate } from './RatingByShopTemplate';

export const RatingByShop = ({ shopId, className }: { shopId: number } & DefaultProps) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [rating, setRating] = useState<RatingShopsType>(null);
  useEffect(() => {
    fetchRatingShops({ listId: [shopId] })
      .then(data => setRating(data[0]))
      .finally(() => setIsLoaded(true));
  }, []);

  if (!isLoaded) {
    return <RatingByShop.Skeleton className={className} />;
  }

  if (isLoaded && !rating) {
    return null;
  }

  return <RatingByShopTemplate className={className} rating={rating.rating?.toString()} reviews={rating.reviews} />;
};

RatingByShop.Skeleton = function Skeleton({ className }: DefaultProps) {
  return <SkeletonLoading className={className} width={'100px'} height={'22px'} />;
};
